// Path: /home/jason/src/AgileView/autovision-ui/src/components/wizards/CPTypeStep.tsx
import React from 'react'
import { Card, Row, Col } from 'react-bootstrap'
import { useProject } from './NewProjectContext'
import { Box, Image as ImageIcon, Square } from 'lucide-react'

const CPTypeStep: React.FC = () => {
  const { projectType, setProjectType } = useProject()

  const cardStyle = {
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    height: '100%',
    backgroundColor: '#2b2b2b',
    borderColor: '#404040',
  }

  const selectedCardStyle = {
    borderColor: '#0d6efd',
    borderWidth: '2px',
    transform: 'translateY(-4px)',
    boxShadow: '0 4px 12px rgba(13, 110, 253, 0.25)',
  }

  return (
    <Row className="justify-content-center">
      <Col xs={10}>
        <Row className="g-4">
          <Col md={4}>
            <Card
              style={{
                ...cardStyle,
                ...(projectType === 'bounding_box' ? selectedCardStyle : {}),
              }}
              className={`h-100 ${projectType === 'bounding_box' ? 'border-primary' : ''}`}
              onClick={() => setProjectType('bounding_box')}
            >
              <Card.Body className="d-flex flex-column align-items-center text-center p-4">
                <div
                  className="rounded-circle bg-primary bg-opacity-25 p-4 mb-3"
                  style={{ width: '100px', height: '100px' }}
                >
                  <Box className="text-primary" size={48} />
                </div>
                <Card.Title className="h4 mb-3 text-light">Bounding Box</Card.Title>
                <Card.Text className="text-light opacity-75">
                  Create a project for object detection with bounding boxes. Perfect for identifying
                  and localizing objects in images.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card
              style={{
                ...cardStyle,
                ...(projectType === 'classification' ? selectedCardStyle : {}),
              }}
              className={`h-100 ${projectType === 'classification' ? 'border-primary' : ''}`}
              onClick={() => setProjectType('classification')}
            >
              <Card.Body className="d-flex flex-column align-items-center text-center p-4">
                <div
                  className="rounded-circle bg-primary bg-opacity-25 p-4 mb-3"
                  style={{ width: '100px', height: '100px' }}
                >
                  <ImageIcon className="text-primary" size={48} />
                </div>
                <Card.Title className="h4 mb-3 text-light">Classification</Card.Title>
                <Card.Text className="text-light opacity-75">
                  Create a project for image classification. Ideal for categorizing images into
                  predefined classes.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card
              style={{
                ...cardStyle,
                ...(projectType === 'oriented_bounding_box' ? selectedCardStyle : {}),
              }}
              className={`h-100 ${projectType === 'oriented_bounding_box' ? 'border-primary' : ''}`}
              onClick={() => setProjectType('oriented_bounding_box')}
            >
              <Card.Body className="d-flex flex-column align-items-center text-center p-4">
                <div
                  className="rounded-circle bg-primary bg-opacity-25 p-4 mb-3"
                  style={{ width: '100px', height: '100px' }}
                >
                  <Square className="text-primary" size={48} />
                </div>
                <Card.Title className="h4 mb-3 text-light">Oriented Bounding Box</Card.Title>
                <Card.Text className="text-light opacity-75">
                  Create a project for object detection with oriented bounding boxes. Ideal for
                  detecting rotated objects with precise angular positioning.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default CPTypeStep
